import PaddedLayout from 'layout/MainLayout/PaddedLayout';

import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import JobPositionsTable from './JobPositionsTable';

type Props = Record<string, never>; // Empty props

const JobPositionsListPage: React.FC<Props> = () => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'job-positions.job-positions'}
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.JOB_POSITION']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/job-position/new`)}
                            labelId="job-positions.add-new-job-position"
                            newLabelId="new-entity.job-position"
                        />
                    }
                />
                <JobPositionsTable />
            </div>
        </PaddedLayout>
    );
};

export default JobPositionsListPage;
